export const environment = {
        production: true,
        baseUrl: 'https://daadgam.com/api/v1/',
        baseUrlV2: 'https://daadgam.com/api/v2/',
        djangoUrl: 'https://daadgam.com',
        recaptcha: {
            siteKey: '6LdcllMkAAAAAEJDLe5su8XbivxayBqAh0L5Nyi4',
            language: 'fa'
        },
        serverMode: 'cloud',
        workflowBaseUrl: "https://workflow.daadgam.com/api/v1/",
	    buildNumber: 1777888220,
       };